import { keepPreviousData, useQuery } from '@tanstack/react-query';

import NlsAnalyticsService, { Category2QueriesParams } from '~/services/NlsAnalyticsService';

import { nlsAnalyticsQueryKeys } from './nlsAnalyticsQueryKeys';
import { nlsAnalyticsQueryOptions } from './nlsAnalyticsQueryOptions';

export function useCategory2Queries({ limit, offset }: Required<Category2QueriesParams>) {
  return useQuery({
    queryKey: nlsAnalyticsQueryKeys.category2Queries(limit, offset),
    queryFn: () => NlsAnalyticsService.getCategory2Queries({ limit, offset }),
    placeholderData: keepPreviousData,
    select: (data) => data.result,
    ...nlsAnalyticsQueryOptions,
  });
}
